module.exports = __webpack_public_path__ + "img/hepatobiliary_pic.a01021e7.png";